import { useReactFlow, Handle, Position, NodeResizer } from "@xyflow/react";
import { InputNumber, Select, Button } from "antd";
import { ClockCircleOutlined, CloseOutlined, CopyOutlined } from "@ant-design/icons";
import NodeNameInput from "./NodeNameInput";

const { Option } = Select;

const DelayNode = ({ data, selected, id }) => {
  const { deleteElements } = useReactFlow();
  const onChange = (field, value) => data.onChange?.({ ...data, [field]: value });

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? "#06b6d4" : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 220,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={240} minHeight={80} isVisible={selected} color="#06b6d4" />
      <Handle type="target" position={Position.Left} style={{ background: "#06b6d4" }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <ClockCircleOutlined style={{ color: "#06b6d4", fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>Delay</strong>
        <Button type="text" size="small" icon={<CopyOutlined />} onClick={() => data.onDuplicate?.()} style={{ marginLeft: "auto", color: "#9ca3af" }} />
        <Button type="text" size="small" icon={<CloseOutlined />} onClick={() => deleteElements({ nodes: [{ id }] })} style={{ color: "#9ca3af" }} />
      </div>

      <div
        className="nodrag"
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <NodeNameInput data={data} />
        <p style={{ fontSize: 11, color: "#6b7280", marginBottom: 8 }}>
          The flow will pause for the specified duration before continuing.
        </p>

        <div style={{ display: "flex", gap: 8 }}>
          <InputNumber
            value={data.duration || 5}
            onChange={(v) => onChange("duration", v)}
            min={1}
            size="small"
            style={{ flex: 1 }}
          />
          <Select
            value={data.unit || "minutes"}
            onChange={(v) => onChange("unit", v)}
            size="small"
            style={{ width: 100 }}
          >
            <Option value="minutes">Minutes</Option>
            <Option value="hours">Hours</Option>
            <Option value="days">Days</Option>
          </Select>
        </div>
      </div>

      <Handle type="source" position={Position.Right} style={{ background: "#06b6d4" }} />
    </div>
  );
};

export default DelayNode;
